import React, { Component } from 'react'
import { Form, Icon, Input, Button, Row, Col, Spin } from 'antd';
import { Link } from 'react-router-dom';
const FormItem = Form.Item;

class ForgotpasswordForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      success: '',
      error: '',
      isLoading: false
    }
    this.handleChange = this.handleChange.bind(this);
  }


  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.form.validateFields((err) => {
      if (!err) {
        // this.props.forgotPassword(this.state.email)
        e.preventDefault();
        var {email} = this.state;
        this.props.sendPassResetEmail(email)
        // var url = 'https://' + domainURL+'/reset-password'
        // this.setState({error:"",success:"",isLoading:true})
        // Axios.post(`${CLOUD_FUNCTION}/api/reset`, {url,email}).then((res) => {
        //   console.log(res)
        //     if (res.data.success) {
        //         message.success(res.data.success)
        //         this.setState({ success: res.data.success ,isLoading:false,email:""})
        //     } else {
        //         message.error(res.data.error)
        //         this.setState({ error: res.data.error ,isLoading:false})
        //     }
        // })
        // .catch((err) => {
        //   console.log(err)
        //   this.setState({
        //     isLoading: false
        //   })
        // })
      }
    });
  }

  render() { 
    const { getFieldDecorator } = this.props.form;
    const {isLoading} = this.state
    return (
      <div className="forgotpass-form">
        <Row>
        <Col
          xs={{ span: 22, offset:1 }}
          sm={{ span: 22, offset:1 }}
          md={{ span: 10, offset: 7 }}
          lg={{ span: 10, offset: 7 }}
        >
          <Spin indicator={<Icon type="loading" style={{ fontSize: 60 }} spin /> } spinning={this.props.loading}>
            <Form
                onSubmit={e => this.handleSubmit(e)}
                className=""
              >
                <div className="xheader">
                  <img src="../../img/logo.png" />
                  <h5>Forgot Password</h5>
                  <p>Enter your registered email address and we'll send you a link to reset your password</p>
                </div>
                <FormItem>
                    {getFieldDecorator('email', {
                      initialValue:this.state.email,

                      rules: [
                        {
                          required: true,
                          message: 'Please input your email'
                        },
                        {
                          type: 'email',
                          message: 'The input is not valid email'
                        }
                      ]
                    })(
                      <Input
                        onChange={e => this.handleChange(e)}
                        prefix={
                          <Icon
                            type="mail"
                            style={{ color: 'rgba(0,0,0,.25)' }}
                          />
                        }
                        name="email"
                        placeholder="Email"
                      />
                    )}
                  </FormItem>
                  <FormItem className="login-btn">
                    <Button
                      block
                      type="primary"
                      htmlType="submit"
                      className="xpad-btn"
                    >
                      Reset Password
                    </Button>
                  </FormItem>
                  <div className="form-footer"><hr />
                       Already have an account? <span onClick={this.props.toggleModal}>Login</span>
                      <br />  Don't have an account? <Link to="/signup" className="link">Signup</Link>{' '}

                    </div>            
            </Form>
          </Spin>
        </Col>
        </Row>
      </div>
    )
  }
}

const WrappedForgotpasswordForm = Form.create()(ForgotpasswordForm);

export default WrappedForgotpasswordForm